module.exports = __webpack_public_path__ + "static/media/guitar.28952093.jpg";